import { Lookup, LookupItem } from "@data-types";
import { httpClient, getApplicationHeaders, retryRequest } from "@utils";

class PlatformTitlesApiService {
	static get baseUrl() {
		return `${WEBPACK_BASE_ADDRESS}platform/user-titles`;
	}

	static getRequestHeaders = () => {
		const appHeaders = getApplicationHeaders();
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async findTitles(): Promise<Lookup<LookupItem>> {
		const response = await retryRequest(() =>
			httpClient.get(
				`${this.baseUrl}?translate=true`,
				this.getRequestHeaders(),
				{
					responseType: "json",
				}
			)
		);

		return response;
	}
}

export default PlatformTitlesApiService;
